import { Component, computed, input } from '@angular/core';
import { AppInfo } from '../../../../global/environment';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { SkeletonLoaderComponent } from '../../../../shared/components/skeleton-loader/skeleton-loader.component';
import { MmrService } from '../../services/mmr.service';

@Component({
  selector: 'app-smart-fix-hub',
  imports: [ButtonComponent, SkeletonLoaderComponent],
  templateUrl: './smart-fix-hub.component.html',
  styleUrl: './smart-fix-hub.component.scss',
  host: {
    class: 'p-24 md-p-16',
    '[class.loading]': 'loading()',
  },
})
export class SmartFixHubComponent {
  loading = input.required<boolean>();

  protected viewModel = computed(() => {
    const planValue = this.mmrService.planClaimsDetails.plan;

    return {
      loading: this.loading(),
      url: `${AppInfo.Environment.smartFixHubUrl}/your-appliance?applianceCode=${planValue.value()?.itemCode}&planNumber=${planValue.value()?.planNumber}`,
    };
  });

  get vm() {
    return this.viewModel();
  }

  constructor(private readonly mmrService: MmrService) {}
}
